import 'dayjs/locale/ru'
import { Dayjs } from 'dayjs'

const ru = {
  calendar: {
    sameDay: '[Сегодня, в] LT',
    nextDay: '[Завтра, в] LT',
    lastDay: '[Вчера, в] LT',
    nextWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[В следующее] dddd, [в] LT')
        case 1:
        case 2:
        case 4:
          return now.format('[В следующий] dddd, [в] LT')
        case 3:
        case 5:
        case 6:
          return now.format('[В следующую] dddd, [в] LT')
      }
    },
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[В прошлое] dddd, [в] LT')
        case 1:
        case 2:
        case 4:
          return now.format('[В прошлый] dddd, [в] LT')
        case 3:
        case 5:
        case 6:
          return now.format('[В прошлую] dddd, [в] LT')
      }
    },
    sameElse: 'L'
  }
}

export default ru
